import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { ValidateExpression } from "../../../Models/UserInterfaces/ValidateExpression";

export class ValidateExpressionEvaluator implements IExpressionEvaluator<ValidateExpression> {
  get type(): string {
    return "UserInterface.Validate";
  }

  evaluate(expression: ValidateExpression, context: IExpressionEvaluatorContext): MaybePromise {
    return true;
  }
}
